__turbopack_context__.v({
  "opacity_bg": "Cji9pa_opacity_bg",
});
